'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'

export default function ScrollToTop() {
  const pathname = usePathname()

  useEffect(() => {
    // Fragment navigation already positions the requested section. Do not
    // overwrite that position when the destination finishes hydrating.
    const frame = requestAnimationFrame(() => {
      if (window.location.hash) {
        let id: string
        try { id = decodeURIComponent(window.location.hash.slice(1)) } catch { return }
        document.getElementById(id)?.scrollIntoView({ block: 'start', behavior: 'instant' })
        return
      }
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
    })
    return () => cancelAnimationFrame(frame)
  }, [pathname])

  return null
}
